/** Maps a document status to the Badge color variant used to render it. */
export const statusMap = {
    cancelled: 'danger',
    complete: 'success',
    sent: 'incomplete',
    partial: 'common',
    voided: 'common',
};
/**
 * Translation keys for each document status. `ec__status` arrives as a raw enum from Cortex,
 * so we map it to a localized label rather than rendering it verbatim. Keep this in sync with
 * `DOCUMENT_STATUSES` — `signed_document_status.helpers.spec.ts` fails if a status is missing.
 */
export const statusLabelMap = {
    cancelled: 'label.participant_documents.status.cancelled',
    complete: 'label.participant_documents.status.complete',
    sent: 'label.participant_documents.status.sent',
    partial: 'label.participant_documents.status.partial',
    voided: 'label.participant_documents.status.voided',
};
/**
 * Statuses the backend's `void_document` route will still act on. `cancelled` and `voided`
 * are already-terminal — the route rejects them with `documentAlreadyVoided`, so the UI
 * gates on this list rather than relying on that fault to hide the action after the fact.
 */
const VOIDABLE_DOCUMENT_STATUSES = ['sent', 'partial', 'complete'];
export const isDocumentVoidable = (status) => VOIDABLE_DOCUMENT_STATUSES.includes(status);
